// activityInviteFriend
export default {
  routerTitle: '邀請好友',
  shareTitle: '新客戶三種獎賞，享最高HKD 3,800新人禮包！',
  shareDesc: '參與入金交易達標即可獲得！',
  btnTxt: '邀請好友 領取獎勵',
  people: '人',

  cardOneLabel1: '分享好友',
  cardOneLabel2: '註冊開戶',
  cardOneLabel3: '好友入金',

  cardTwoTitle: '邀請好友入金獲取獎勵',
  cardTwoTableLHeader: '邀請人數',
  cardTwoTableRHeader: '邀請獎勵',
  cardTwoTableEmptyTips: '暫無數據',
  cardTwoTips:
    '注：<br/>1、邀請11-30人以上，每邀請1位達標入金≥2w HKD，交易≥1筆，可獲得HKD450。<br/>2、被邀請人需滿足入金≥2w HKD，交易≥1筆，詳看活動規則。',
  cardTwoTips2:
    '註：1、邀請11-30人以上，每邀請1位達標入金≥HKD 2W，交易≥1筆，可獲得HKD 450。 <br/>2、被邀請人需滿足入金≥HKD 2W，交易≥1筆，詳看活動規則。 <br/>3、被邀請人獎勵：首次入金達標≥HKD 2W，30天內無出金記錄且交易≥1筆，最高可拿HKD 3800新人禮包！ ',

  cardThreeTitle: '我的邀請',
  cardThreeTableLHeader: '我的邀請',
  cardThreeTableRHeader: '邀請時間',
  cardThreeTableRHeader2: '達標情況',
  cardThreeTableEmptyTips: '暫無邀請進度',
  cardThreePreviewAmount: '預估可得',
  cardThreeHasInvited: '已邀請',
  cardThreeEarnReward: '獲得 {name} 獎勵',

  cardFourTitle: '邀請排行榜',
  cardFourTableLHeader: '用戶暱稱',
  cardFourTableRHeader: '邀請人數',
  cardFourTableEmptyTips: '暫無數據，等你來上榜',
  cardFourTips:
    '注：排名前六的用戶分別獲得IPhone 14 (256G)、Air Pods Pro、Apple HomePod mini、科沃斯掃地機器人K650、米家噴墨打印一體機、華為手環7標準版',
  cardFourTips2:
    '註：前六名的用戶分別獲得華為Mate 60 Pro 12GB、Air Pods Pro、Apple HomePod mini、科沃斯掃地機器人K650、米家噴墨打印一體機、華為手環7標準版',

  inviteLinkCopyTips: '邀請好友鏈接已複製'
}
